import * as PIXI from "pixi.js-legacy";

class Frames {

    constructor() {

        this.bar = [];
        this.blue = [];
        this.green = [];
        this.orange = [];
        this.purple = [];
        this.seven = [];
        this.wild = [];
        this.yellow = [];
        this.logo = [];
    }

    init() {
        for (let i = 0; i < 17; i++) {
            let val = i < 10 ? '0' + i : i; // push frames
            this.bar.push(PIXI.Texture.from('symbol_crystal_bar_000' + val + '.png'));
        }
        for (let i = 0; i < 17; i++) {
            let val = i < 10 ? '0' + i : i; // push frames
            this.blue.push(PIXI.Texture.from('symbol_crystal_blue_000' + val + '.png'));
        }
        for (let i = 0; i < 17; i++) {
            let val = i < 10 ? '0' + i : i; // push frames
            this.green.push(PIXI.Texture.from('symbol_crystal_green_000' + val + '.png'));
        }
        for (let i = 0; i < 17; i++) {
            let val = i < 10 ? '0' + i : i; // push frames
            this.orange.push(PIXI.Texture.from('symbol_crystal_orange_000' + val + '.png'));
        }
        for (let i = 0; i < 17; i++) {
            let val = i < 10 ? '0' + i : i; // push frames
            this.purple.push(PIXI.Texture.from('symbol_crystal_purple_000' + val + '.png'));
        }
        for (let i = 0; i < 17; i++) {
            let val = i < 10 ? '0' + i : i; // push frames
            this.seven.push(PIXI.Texture.from('symbol_crystal_seven_000' + val + '.png'));
        }
        for (let i = 0; i < 17; i++) {
            let val = i < 10 ? '0' + i : i; // push frames
            this.wild.push(PIXI.Texture.from('symbol_crystal_wild_win_000' + val + '.png'));
        }
        for (let i = 0; i < 17; i++) {
            let val = i < 10 ? '0' + i : i; // push frames
            this.yellow.push(PIXI.Texture.from('symbol_crystal_yellow_000' + val + '.png'));
        }
        for (let i = 0; i < 13; i++) {
            let val = i < 10 ? '0' + i : i; // push frames
            this.logo.push(PIXI.Texture.from('logo_000' + val + '.png'));
        }
    }

    getAnimatedSprite(frames, x, y, speed, scale = {x: 1, y: 1}, anchor = {x: .5, y: .5}) {
        let anim = new PIXI.AnimatedSprite(frames);
        anim.anchor.set(anchor.x, anchor.y);
        anim.animationSpeed = speed;
        anim.position.set(x, y);
        anim.scale.set(scale.x, scale.y);
        anim.loop = false;
        return anim;
    }

    getFramesBySymbol(symbolName) {
        switch (symbolName) {
            case "symbol_crystal_bar":
                return this.bar;
            case "symbol_crystal_blue":
                return this.blue;
            case "symbol_crystal_green":
                return this.green;
            case "symbol_crystal_orange":
                return this.orange;
            case "symbol_crystal_purple":
                return this.purple;
            case "symbol_crystal_seven":
                return this.seven;
            case "symbol_crystal_wild":
                return this.wild;
            case "symbol_crystal_yellow":
                return this.yellow;

        }
    }
}

export default new Frames();